import axios from '../axios'
import { getHeadersWithJwtToken } from 'auth/utils/auth-util'
import { userManager } from 'auth/services/auth.service'
import { apiRoutes } from 'selfServicePortal/constants/routes'
import { logError } from 'shared'

export async function getMigrationEligibleService(): Promise<boolean> {
	const user = await userManager.getUser()
	const customerId = user?.profile.sub

	const response = await axios
		.get<boolean>(
			apiRoutes.getMigrationEligible(customerId!),
			await getHeadersWithJwtToken(),
		)
		.then(({ data }) => data)
		.catch((err) => {
			logError(err)
			throw err
		})
	return response
}

export async function migrateService(): Promise<void> {
	const user = await userManager.getUser()
	const customerId = user?.profile.sub

	await axios
		.post(
			apiRoutes.migrate(customerId!),
			{},
			await getHeadersWithJwtToken(),
		)
		.catch((err) => {
			logError(err)
			throw err
		})
}
